import { render } from "./taxYearTax.vue?vue&type=template&id=4f1b1dfb&scoped=true"
import script from "./taxYearTax.vue?vue&type=script&lang=js"
export * from "./taxYearTax.vue?vue&type=script&lang=js"

import "./taxYearTax.vue?vue&type=style&index=0&id=4f1b1dfb&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1b1dfb"]])

export default __exports__